import i18next from 'i18next';

/** English names for the app's supported UI languages, keyed by short code. */
const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
};

/**
 * A prompt instruction telling the Ask agent which language to answer in, based on
 * the user's current UI language. The gateway doesn't receive the locale otherwise,
 * so without this the model tends to default to English regardless of the UI setting.
 */
export function languageDirective(): string {
  const shortCode = (i18next.language ?? 'en').split('-')[0];
  const name = LANGUAGE_NAMES[shortCode] ?? shortCode;
  return `Write your entire response in ${name}.`;
}
